import Home from "../pages/home";


const App = () => {
  return (
    <div className='main-container'>
      <Home />
    </div>
  );
}

export default App;